import AssignmentsExperiments from 'bundles/epic/clients/Assignments';

export const isChunkedVerifiedSkillAssessmentsEnabled = () => {
  return AssignmentsExperiments.get('enableChunkedVerifiedSkillAssessments');
};
